import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/employee/id/:employee_id/",
      name: "employee",
      meta: { requiresAuth: true, title: "routes.employee" },
      component: () => import("./main.vue")
    },
    {
      path: "/module/employee/employmentStatement/:employment_id/:employee_id",
      name: "employmentStatement",
      meta: { requiresAuth: true, title: "routes.employmentStatement" },
      component: () => import("./employmentStatement.vue")
    }
  ]
};
